<template>
  <div class="tab-content">
    <div class="partner-cards">
      <!-- 企业OEM卡片 -->
      <div class="partner-card">
        <div class="card-header">
          <h3>{{ $t('partnerRecharge.oemCard.title') }}</h3>
        </div>
        <div class="qrcode-wrapper">
          <img v-if="systemConfigStore.commonConfig?.serviceQrUrl" :src="systemConfigStore.commonConfig.serviceQrUrl"
            class="qrcode-image" :alt="$t('contactBusiness.qrCodeAlt')" />
          <div v-else class="qrcode-placeholder"></div>
          <div class="partner-info">
            <h4>{{ $t('partnerRecharge.oemCard.subtitle') }}</h4>
            <p>{{ $t('partnerRecharge.contactBusiness') }}</p>
          </div>
        </div>
        <div class="action-btn">
          <button class="contact-btn" @click="openContactDialog">
            {{ $t('partnerRecharge.contactBusiness') }}
          </button>
        </div>
        <div class="features-list">
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.oemCard.feature1') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.oemCard.feature2') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.oemCard.feature3') }}</span>
          </div>
        </div>
      </div>

      <!-- 企业API卡片 -->
      <div class="partner-card api-card">
        <div class="card-tag">{{ $t('partnerRecharge.apiCard.tag') }}</div>
        <div class="card-header">
          <h3>{{ $t('partnerRecharge.apiCard.title') }}</h3>
        </div>
        <div class="qrcode-wrapper">
          <img v-if="systemConfigStore.commonConfig?.serviceQrUrl" :src="systemConfigStore.commonConfig.serviceQrUrl"
            class="qrcode-image" :alt="$t('contactBusiness.qrCodeAlt')" />
          <div v-else class="qrcode-placeholder"></div>
          <div class="partner-info">
            <h4>{{ $t('partnerRecharge.apiCard.subtitle') }}</h4>
            <p>{{ $t('partnerRecharge.contactBusiness') }}</p>
          </div>
        </div>
        <div class="action-btn">
          <button class="contact-btn" @click="openContactDialog">
            {{ $t('partnerRecharge.contactBusiness') }}
          </button>
        </div>
        <div class="features-list">
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.apiCard.feature1') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.apiCard.feature2') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.apiCard.feature3') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.apiCard.feature4') }}</span>
          </div>
          <div class="feature-item">
            <span class="feature-text">{{ $t('partnerRecharge.apiCard.feature5') }}</span>
          </div>
        </div>
      </div>
    </div>
    <ContactDialog ref="serviceDialogRef" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig';
import ContactDialog from "@/components/dialog/ContactDialog.vue";
const serviceDialogRef=ref();
const emit = defineEmits(['recharge'])
const systemConfigStore = useSystemConfigStoreHook()
// 打开联系弹窗
const openContactDialog = () => {
  serviceDialogRef.value.showServiceDialog();
}
</script>

<style scoped>
.tab-content {
  padding: 10px 0 30px;
}

.partner-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 0;
}

.partner-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 0;
  background-color: #fff;
  position: relative;
  transition: all 0.3s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.partner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.api-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  padding: 0;
  background-color: #fff;
  position: relative;
  transition: all 0.3s;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.api-card::before {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.card-tag {
  position: absolute;
  top: 10px;
  right: -30px;
  transform: rotate(45deg);
  padding: 5px 30px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  text-align: center;
  background-color: var(--el-color-primary);
  z-index: 2;
}

.card-header {
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.card-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

.qrcode-wrapper {
  display: flex;
  align-items: center;
  padding: 20px;
  gap: 20px;
}

.qrcode-placeholder {
  width: 130px;
  height: 130px;
  background-color: #000;
  border-radius: 8px;
  flex-shrink: 0;
}

.qrcode-image {
  width: 130px;
  height: 130px;
  border-radius: 8px;
  flex-shrink: 0;
  object-fit: cover;
}

.partner-info {
  text-align: left;
}

.partner-info h4 {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #333;
}

.partner-info p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

.card-title,
.card-subtitle {
  display: none;
}

.action-btn {
  padding: 0 20px 20px;
  text-align: center;
  margin-top: 0;
}

.contact-btn {
  width: 100%;
  padding: 12px 0;
  border: none;
  border-radius: 30px;
  background: linear-gradient(to right, var(--color-gradient-start), var(--el-color-primary));
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.contact-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--el-color-primary-rgb), 0.3);
}

.features-list {
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.feature-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 0;
}

.feature-text {
  font-size: 14px;
  color: #333;
}
</style>
